import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2020 } from "../../../../data/Convenios/dataConvenios";

const Convenios2020 = () => <ConveniosYearPage year={2020} data={convenios2020} />;

export default Convenios2020;